import { css } from 'emotion';

const viewCertificate = theme => css`
  display: flex;
  align-items: center;
  margin-left: 20px;
  color: ${theme.color.accent};
  fill: ${theme.color.accent};
  cursor: pointer;
  height: 20px;
  font-size: 12px;
  text-transform: capitalize;

  .icon {
    margin-right: 3px;
    fill: inherit;
  }
`;

export default {
  viewCertificate
};
